// Time-zone options for the Quick Start & Company Profile pickers — iter48.
//
// A lean, US-first list of IANA identifiers with friendly labels. This
// covers ~all contractor use cases without dumping the browser's full
// Intl.supportedValuesOf("timeZone") list (600+ entries) on the picker.
// Contractors that need something exotic can still edit the value from a
// full Company Profile save via the API.

export const TIME_ZONE_OPTIONS = [
  // United States
  { value: "America/New_York",    label: "US · Eastern (New York)" },
  { value: "America/Chicago",     label: "US · Central (Chicago)" },
  { value: "America/Denver",      label: "US · Mountain (Denver)" },
  { value: "America/Phoenix",     label: "US · Mountain, no DST (Phoenix)" },
  { value: "America/Los_Angeles", label: "US · Pacific (Los Angeles)" },
  { value: "America/Anchorage",   label: "US · Alaska (Anchorage)" },
  { value: "Pacific/Honolulu",    label: "US · Hawaii (Honolulu)" },
  // Canada
  { value: "America/Toronto",     label: "Canada · Eastern (Toronto)" },
  { value: "America/Winnipeg",    label: "Canada · Central (Winnipeg)" },
  { value: "America/Edmonton",    label: "Canada · Mountain (Edmonton)" },
  { value: "America/Vancouver",   label: "Canada · Pacific (Vancouver)" },
  { value: "America/Halifax",     label: "Canada · Atlantic (Halifax)" },
  // Mexico / Caribbean
  { value: "America/Mexico_City", label: "Mexico · Central (Mexico City)" },
  { value: "America/Tijuana",     label: "Mexico · Pacific (Tijuana)" },
  // Wider coverage (safe fallbacks)
  { value: "UTC",                 label: "UTC (Coordinated Universal Time)" },
];

export const DEFAULT_TIME_ZONE = "America/Chicago";

/**
 * Best-effort browser IANA time-zone detection. Returns a value that lives
 * inside TIME_ZONE_OPTIONS. Falls back safely to DEFAULT_TIME_ZONE.
 */
export const detectBrowserTimeZone = () => {
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (tz && TIME_ZONE_OPTIONS.some((o) => o.value === tz)) return tz;
  } catch {
    // ignore — Intl may be unavailable in some sandbox contexts
  }
  return DEFAULT_TIME_ZONE;
};

export const labelForTimeZone = (value) => {
  const hit = TIME_ZONE_OPTIONS.find((o) => o.value === value);
  return hit ? hit.label : (value || "");
};

export const isKnownTimeZone = (value) =>
  !!value && TIME_ZONE_OPTIONS.some((o) => o.value === value);
